import React from "react";
import "./RecommendationModal.scss";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeInfo } from "./../../../../../store/Partner/modalSlice"; 

const RecommendationModal = () => {
  const dispatch = useDispatch();

  return (
    <div className="modal-overlay" onClick={() => dispatch(closeInfo())}>
      <div className="recommendation-modal" onClick={(e) => e.stopPropagation()}>
        <FaTimes className="close-icon" onClick={() => dispatch(closeInfo())} />

        <h2>
          <em>Build up your Aerial Borne profile with </em>
          <span className="highlight">recommendations</span>
          <em> - it’s super easy</em>
        </h2>

        <div className="steps">
          <p>
            <strong>Step 1</strong> <br />
            Establish credibility by inviting past clients to write a recommendation of your work.
          </p>

          <p>
            <strong>Step 2</strong> <br />
            They’ll get an email with instructions for submitting their review.
          </p>

          <p>
            <strong>Step 3</strong> <br />
            Once we’ve approved it, it will appear on your profile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecommendationModal;
